let count = 0;

export default function viewCounter(state = count, action) {
  switch (action.type) {
    case 'SET_COUNT':
      state = action.payload === 0 ? action.payload : +action.payload;
      return state;
    default:
      return state
  }
}